import $ from 'jquery'
import {getSalesforceEndpoints} from '../util/getSalesforceEndpoints'
import {isCa} from "@/scripts/util/countryCheck"

/**
 * Checks if the license number matches the formats DVS expects
 * @param licenseNumber
 * @param state
 * @returns {boolean}
 */
export function isValidDriversLicence(licenseNumber, state) {
    let pattern = new RegExp(``)
    switch (state) {
        case `Australian Capital Territory`:
        case `Northern Territory`:
        case `Victoria`:
            // Numeric - Up to 10

            pattern = new RegExp(`^[0-9]{6,10}$`)
            break
        case `New South Wales`:
            // Alphanumeric - 6 -> 8
            pattern = new RegExp(`^[a-zA-Z0-9]{6,8}$`)
            break
        case `Queensland`:
            // Numeric - 8 -> 9
            pattern = new RegExp(`^[0-9]{8,9}$`)
            break
        case `South Australia`:
            // Alpha Numeric, 6
            pattern = new RegExp(`^[a-zA-Z0-9]{6}$`)
            break
        case `Tasmania`:
            // Alpha Numeric, 6 -> 8
            pattern = new RegExp(`^[a-zA-Z0-9]{6,8}$`)
            break
        case `Western Australia`:
            // Numeric - 7
            pattern = new RegExp(`^[0-9]{7}$`)
            break
    }
    return pattern.test(licenseNumber)
}

/**
 * Uses regex to determine if the value is valid based on state. Some states share format which makes it easier.
 * @param number
 * @param state
 * @returns {boolean}
 */
export function isValidDriversLicenseCardNumber(number, state) {
    let pattern = new RegExp(``)
    switch (state) {
        case `Australian Capital Territory`:
        case `Queensland`:
            // Alphanumeric - 10
            pattern = new RegExp(`^[a-zA-Z0-9]{10}$`)
            break
        case `New South Wales`:
            // Numeric - 10
            pattern = new RegExp(`^[0-9]{10}$`)
            break
        case `Northern Territory`:
            // Numeric - 6 -> 8
            pattern = new RegExp(`^[0-9]{6,8}$`)
            break
        case `South Australia`:
        case `Tasmania`:
            // Alpha Numeric, 9
            pattern = new RegExp(`^[a-zA-Z0-9]{9}$`)
            break
        case `Victoria`:
            pattern = new RegExp(`^[a-zA-Z0-9]{8}$`)
            break
        case `Western Australia`:
            pattern = new RegExp(`^[a-zA-Z0-9]{8,10}$`)
            break
    }
    return pattern.test(number)
}

/**
 * Parse the Phone number and parse through util function to return RAW phone number
 * @param {PhoneUtilLibrary} util
 * @param {HTMLElement} element
 * @param country
 * @returns
 */
export function getRawPhoneNumber(util, element, country = `au`) {
    let el_value = element.value.replaceAll(`x`, ``).trim()
    return element && el_value && el_value.length > 2
        ? util.parseAndKeepRawInput(`${element.value}`, country)
        : false
}


/**
 * Check if the Number inserted is a Australian Mobile Number
 * Resource: https://github.com/google/libphonenumber
 * Resource: https://www.npmjs.com/package/google-libphonenumber
 * @param {*} util
 * @param {*} phoneNumberType
 * @param {*} phoneNumber
 * @returns
 */
export function checkIsMobileNumber(util, phoneNumberType, phoneNumber) {
    return (
        util.getNumberType(phoneNumber) === phoneNumberType.MOBILE ||
        (
            isCa() &&
            util.getNumberType(phoneNumber) === phoneNumberType.FIXED_LINE_OR_MOBILE
        )
    )
}

/**
 * Check if Valid Australia Medicare Number
 * @param {string} medicare
 * @returns
 */
export function validateMedicare(medicare) {
    let isValid = false

    const formattedString = medicare.replace(/\s+/g, ``)

    if (medicare && formattedString.length === 10) {
        const matches = formattedString.match(/^(\d{8})(\d)/)

        if (!matches) {
            // return { invalid: true };
            // throw error - it is not matching the right expression
            return false
        }

        const base = matches[1]
        const checkDigit = matches[2]
        const multipliers = [1, 3, 7, 9, 1, 3, 7, 9]

        let sum = 0
        for (let i = 0; i < multipliers.length; i++) {
            sum += parseInt(base[i], 10) * multipliers[i]
        }

        isValid = sum % 10 === parseInt(checkDigit, 10)
    }

    return isValid
}

/**
 * Toggles the UI for Search Type for the ABN Call
 * @param {Event} event
 * @param {HTMLElement[]} buttons
 * @param {HTMLElement[]} fieldGroups
 * @param {function} resetResults
 * @param {function} resetSelectedBusiness
 */
export const toggleSearchTypeFields = function (
    event,
    buttons,
    fieldGroups,
    resetResults,
    resetSelectedBusiness
) {
    event.preventDefault()
    const target = event.target.dataset.toggleTarget
    const selectedFieldWrapper = document.querySelector(target)
    buttons.forEach(button => button.classList.remove(`active`))
    fieldGroups.forEach(wrapper => {
        wrapper.classList.add(`hide`)
        wrapper.classList.remove(`active`)
        wrapper.classList.remove(`is-completed`)
        wrapper.querySelector(`input`).removeAttribute(`data-required`)
    })
    selectedFieldWrapper.classList.remove(`hide`)
    selectedFieldWrapper.classList.add(`active`)
    selectedFieldWrapper.querySelector(`input`).setAttribute(`data-required`, ``)
    selectedFieldWrapper.querySelector(`input`).focus()
    event.target.classList.add(`active`)
    resetResults()
    resetSelectedBusiness()
}

/**
 * This function changes descriptiive text for the 'finance product of interest' dropdown
 * Based on the selected option, the text will update accordingly.
 */
const updateFinanceProductDescriptionText = value => {
    const elements = {
        $descriptiveText: document.querySelectorAll(
            `[data-finance-product-description]`
        ),
        $selectedOption: document.querySelector(
            `[data-finance-product-description="${value}"]`
        ),
    }
    elements.$descriptiveText.forEach(el => el.classList.add(`is-hidden`))
    elements.$selectedOption &&
    elements.$selectedOption.classList.remove(`is-hidden`)
}

const handleFinanceProductInputChange = inputs => {
    inputs &&
    inputs.forEach(input =>
        input.addEventListener(`change`, event =>
            updateFinanceProductDescriptionText(event.target.value)
        )
    )
}

export function initFinanceProductDescriptionText() {
    const elements = {
        $radioButtons: document.querySelectorAll(
            `input[name='application_product']`
        ),
    }
    handleFinanceProductInputChange(elements.$radioButtons)
}

/**
 * This function prevents the 'Enter' key from being pressed and submitting a HTML form
 */
export function preventEnterKeySubmittingForm(formSelector) {
    formSelector &&
    formSelector.addEventListener(`keydown`, e => {
        const key = e.key
        const fallBackKey = e.keyCode || e.which || e.charCode || 0
        if (key && key === `Enter`) {
            e.preventDefault()
            e.stopPropagation()
            return false
        } else if (fallBackKey && fallBackKey === 13) {
            e.preventDefault()
            e.stopPropagation()
            return false
        }
    })
}

/**
 * UI function that animates the Application Form Submit button on submit
 */
function animateSubmitButton() {
    const spinner = $(`#applicationSubmitSpinner`)
    const buttonText = $(`#applicationSubmitText`)
    spinner && spinner.removeClass(`hide`)
    buttonText && buttonText.addClass(`hide`)
}

/**
 * Set the Formatted Date of Birth & Sales Force Date of Birth field values based on the Country
 * @param {*} day - string: text value 0-31
 * @param {*} month - string: jan-dev
 * @param {*} year  - string: 1920 - 2019
 * @param {*} country - string: AU, CA & NZ
 * @param {*} $formattedBirthdayField - element: hidden field used for UI
 * @param {*} $submittedBirthdayField - element: hidden field submits to Sales Force
 */
export function setDateOfBirthFieldValues({
                                              day,
                                              month,
                                              year,
                                              country,
                                              $formattedBirthdayField,
                                              $submittedBirthdayField,
                                          }) {
    const submittedDateOfBirthValue = `${day}/${month}/${year}`

    const BIRTHDAY_FORMATS_BY_COUNTRY = {
        AU: {
            formattedDateOfBirth: `${day}/${month}/${year}`,
        },
        NZ: {
            formattedDateOfBirth: `${day}/${month}/${year}`,
        },
        CA: {
            formattedDateOfBirth: `${year}/${month}/${day}`,
        },
    }

    // this value is shown visually in the UI
    $formattedBirthdayField.value =
        BIRTHDAY_FORMATS_BY_COUNTRY[country].formattedDateOfBirth

    // this value is submitted to sales force
    $submittedBirthdayField.value = submittedDateOfBirthValue
}

/**
 * Submits the form
 *
 * @param submitButton
 * @param applicationForm
 */
export function setSubmitApplicationFormEvent(submitButton, applicationForm) {
    submitButton.addEventListener(`click`, e => {
        e.preventDefault()

        const {action_application_form_url: actionApplicationUrl} = getSalesforceEndpoints()

        const setActionUrl = () =>
            applicationForm.setAttribute(`action`, actionApplicationUrl)

        const setButtonDisabled = () =>
            submitButton.classList.add(`disabled`, `is-loading`)

        if (!actionApplicationUrl) {
            alert(`Error - Application Form: No Action URL`)
            console.error(`Application Form: No Action URL`)
            return
        }

        setButtonDisabled()
        animateSubmitButton()
        setActionUrl()

        try {
            if (applicationForm.requestSubmit) {
                if (submitButton) {
                    applicationForm.requestSubmit(submitButton)
                } else {
                    applicationForm.requestSubmit()
                }
            } else {
                // Fallback for browsers that do not support requestSubmit()
                applicationForm.submit()
            }
        } catch (err) {
            console.error(`error`, err)
        }
    })
}

export function setMiddleNameDropdownEvent() {
    let middleNameDropdown = document.getElementById(`has_middle_name`)
    middleNameDropdown.addEventListener(`input`, (event) => {
        let middleNameField = document.getElementById(`middle_name`)
        let middleNameDiv = document.getElementById(`middle_name_input_div`)
        if (event.target.value === `y`) {
            middleNameField.type = `text`
            middleNameField.value = ``
            middleNameField.setAttribute(`data-required`, `true`)
            middleNameDiv.classList.remove(`hidden`)
        } else {
            middleNameField.type = `hidden`
            middleNameField.value = ``
            middleNameField.removeAttribute(`data-required`)
            middleNameDiv.classList.add(`hidden`)
        }
    })
}
